import { optionField } from '@/common/utils/form/fieldTypes';
import { SurveyDifferenceApplicableType } from '@/types/company-settings';

export const apply_the_bunker_survey_difference_as_correction_to =
  'apply_the_bunker_survey_difference_as_correction_to';

export const apply_the_lubricant_survey_difference_as_correction_to =
  'apply_the_lubricant_survey_difference_as_correction_to';

export type BunkerSurveyDifferenceApplicableOptionType = {
  label: string;
  value: SurveyDifferenceApplicableType;
};

export type CaptainReportsType = {
  [apply_the_lubricant_survey_difference_as_correction_to]: SurveyDifferenceApplicableType | null;
  [apply_the_bunker_survey_difference_as_correction_to]: SurveyDifferenceApplicableType | null;
};

const config = {
  [apply_the_lubricant_survey_difference_as_correction_to]: optionField(),
  [apply_the_bunker_survey_difference_as_correction_to]: optionField()
};

export default config;
